import React from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import ProductCard from "@/components/ProductCard";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const KEY = "novalynx_recently_viewed_v1";
const MAX = 8;

// --- storage helpers ---
export function readRecentlyViewed() {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw).filter((v) => typeof v === "string") : [];
  } catch {
    return [];
  }
}
export function pushRecentlyViewed(productId) {
  if (!productId) return;
  const list = readRecentlyViewed().filter((id) => id !== productId);
  list.unshift(productId);
  try {
    localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
  } catch { /* quota: ignore */ }
}

/**
 * Recently Viewed strip.
 * - `excludeId` — omit the current product (used on the product page)
 * - `title` — override default heading
 * - Renders nothing if the strip would be empty
 */
export default function RecentlyViewed({ excludeId, title = "Recently viewed" }) {
  const [products, setProducts] = React.useState([]);
  const [loaded, setLoaded] = React.useState(false);

  React.useEffect(() => {
    const ids = readRecentlyViewed().filter((id) => id !== excludeId).slice(0, MAX);
    if (ids.length === 0) { setLoaded(true); return; }
    let cancelled = false;
    axios
      .get(`${API}/products/by-ids`, { params: { ids: ids.join(",") } })
      .then((r) => { if (!cancelled) setProducts(r.data || []); })
      .catch(() => {})
      .finally(() => { if (!cancelled) setLoaded(true); });
    return () => { cancelled = true; };
  }, [excludeId]);

  if (!loaded || products.length === 0) return null;

  return (
    <section className="mt-16" data-testid="recently-viewed">
      <div className="flex items-end justify-between mb-6">
        <h2 className="font-display text-2xl font-bold">{title}</h2>
        <Link to="/shop" className="text-sm text-muted-foreground hover:text-primary transition">
          Keep browsing →
        </Link>
      </div>
      <div className="flex gap-4 overflow-x-auto pb-2 -mx-4 px-4 sm:mx-0 sm:px-0 snap-x snap-mandatory sm:snap-none">
        {products.map((p) => (
          <div key={p.product_id} className="min-w-[220px] sm:min-w-0 sm:flex-1 snap-start" data-testid={`recent-${p.product_id}`}>
            <ProductCard product={p} />
          </div>
        ))}
      </div>
    </section>
  );
}
